import { useState } from 'react';
import { Button, Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { Download, FileSpreadsheet, FileText } from 'lucide-react';
import { toast } from 'sonner';
import { exportarFluxoCaixa } from '../utils/fluxoCaixaExport';
import { calcularResumoDeLancamentos } from '../utils/fluxoCaixaCalculations';
import {
  FluxoCaixaExportFormato,
  FluxoCaixaFiltros,
  FluxoCaixaLancamento,
} from '../types/fluxoCaixa';

interface FluxoCaixaExportButtonProps {
  lancamentos: FluxoCaixaLancamento[];
  filtros: FluxoCaixaFiltros;
  disabled?: boolean;
}

export function FluxoCaixaExportButton({
  lancamentos,
  filtros,
  disabled = false,
}: FluxoCaixaExportButtonProps) {
  const [exportando, setExportando] = useState(false);

  const handleExport = async (formato: FluxoCaixaExportFormato) => {
    try {
      setExportando(true);
      await exportarFluxoCaixa(
        lancamentos,
        calcularResumoDeLancamentos(lancamentos),
        filtros,
        formato
      );
      toast.success(`Exportação ${formato.toUpperCase()} concluída`);
    } catch (err) {
      const e = err instanceof Error ? err : new Error('Erro ao exportar');
      toast.error(e.message);
    } finally {
      setExportando(false);
    }
  };

  const items: MenuProps['items'] = [
    {
      key: 'xlsx',
      label: 'Excel (XLSX)',
      icon: <FileSpreadsheet className="w-4 h-4" />,
      onClick: () => handleExport('xlsx'),
    },
    {
      key: 'csv',
      label: 'CSV',
      icon: <FileText className="w-4 h-4" />,
      onClick: () => handleExport('csv'),
    },
  ];

  return (
    <Dropdown menu={{ items }} trigger={['click']} disabled={disabled || exportando}>
      <Button
        icon={<Download className="w-4 h-4" />}
        loading={exportando}
      >
        Exportar
      </Button>
    </Dropdown>
  );
}
